module.exports = __webpack_public_path__ + "media/images/podpora-8a505902d0cffa8e8e36a128954dcdef.png";